import React, { useEffect, useState } from 'react';
import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { useHistory } from 'umi';
import FirstRowEdition from '@/pages/intelligence/components/TableComponents/components/FirstRowEdition';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import { MetricsTableCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/MetricsTableCloums';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

const getMetricValueOfCvm = (cvm: any, metricKey: string) => {
  if (!cvm || !metricKey) {
    return {};
  }
  const metrics = cvm.metric_info || [];
  const metric = metrics.find((item: any) => item.metric === metricKey);
  if (!metric) {
    return {};
  }
  return { ...metric, growth_ratio: metric?.dod_int };
};

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    pageId,
    dateType,
    tableTotal,
    dataSource = 'appannie',
    columnsList,
    tableLoading,
    onTableSortChage,
    onTablePagingChange,
    entityType,
  } = props;

  const history = useHistory();
  const { formatMessage } = useIntlExtend();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState({
    currentSortValue: 'desc',
    currentSortMetric: 'MAU',
    currentRatioType: 0,
  });
  const defaultPageSize = 5;
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const {
    // tablePageIndex,
    // tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    // currentOrderSource,
  } = pageSortAttr || {};

  useEffect(() => {
    setSortTableData(tableData);
  }, [JSON.stringify(tableData)]);

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e?.ratioType || 0,
    });
    onTableSortChage({
      ...e,
      sortMetric: e.sortMetric?.toLocaleLowerCase(), //排序时是大写（与后端返回数据一至），传参时是小写（配合后端参数）
    });
    //将页码重置,与接口一至
    setPageIndex(1);
    setPageSize(defaultPageSize);
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    columnsList?.forEach((t) => {
      metricCloums.push(
        MetricsTableCloums({
          /**MetricsTable页只有降序功能 */
          onlySimpleSort: false,
          renderType: t?.renderType,
          width: 'auto', //t?.width,
          dataSource: t?.dataSource, //source === 'ogdb' ? 'databarin' : source,
          title: t?.text,
          textContent: t?.info,
          tipText: t?.iconInfo,
          key: `${t?.value}`,
          sortMetric: t?.value,
          currentSortValue: currentSortValue,
          currentSortKey: `${currentSortMetric}_${currentRatioType}`,
          onSortChage: onSortChage,
          dateType: dateType,
          pageId: pageId,
          getMetricValueOfCvm: getMetricValueOfCvm,
          growthValueType: 'percentValue',
          formatMessage,
          entityType
        }),
      );
    });
    return metricCloums;
  };

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onClickGame = (gameId: string) => {
    history.push(getDetailGameOverviewPath(gameId, entityType));
  };

  return (
    <>
      <TopchartTable
        recordKey="app_id"
        loading={tableLoading}
        records={sortTableData}
        tableTotal={tableTotal}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        pageSizeOptions={[5, 10, 15]}
        className="dbi-mobileGames-details-table"
        columns={[
          {
            key: 'game_id',
            header: (
              <div className="stats-table-title">
                <span className="stats-table-title-text">
                  {formatMessage({ id: 'dbi_games' })}
                </span>
                <span className="stats-table-title-subtext">
                  ({tableTotal || 0})
                </span>
              </div>
            ),
            width: 'auto',
            align: 'left',
            render: (cvm: any) => {
              if (cvm?.id === 'All Games') {
                return <>{formatMessage({ id: 'dbi_detail_table_allgames' })}</>;
              }
              return (
                <ARightClickToJump
                  href={getDetailGameOverviewPath(cvm?.game_id, entityType)}
                  style={{ display: 'inline' }}
                >
                  <FirstRowEdition
                    name={cvm?.game_name}
                    isUnPublished={false}
                    platform={cvm?.platform}
                    imgSrc={cvm?.cover}
                    onClick={() => {
                      onClickGame(cvm?.game_id);
                    }}
                  />
                </ARightClickToJump>
              );
            },
          },
          ...getMetricCloums(dataSource),
        ]}
      />
    </>
  );
};

export default TrendsCard;
